import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { SecurityService } from '@rocksoft/locations-sdk';
import { LocationAclEffects } from './location-acl.effects';
import { locationAclReducer } from './location-acl.reducer';

export const provideLocationAclStore = () => [
  provideState('locationAcls', locationAclReducer),
  provideEffects([LocationAclEffects]),
  SecurityService,
];
